import React from "react";
import { Box, Typography, TextField, Grid } from "@mui/material";

const SizeControl = ({
  width,
  height,
  onChangeWidth,
  onChangeHeight,
  label = "Tamaño (cm)",
}) => {
  return (
    <Box>
      <Typography variant="body2" color="text.secondary" mb={1} fontWeight={500}>
        {label}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            fullWidth
            type="number"
            size="small"
            label="Ancho"
            value={width || ""}
            onChange={(e) => onChangeWidth(e.target.value)}
            inputProps={{ step: "0.1", min: "0" }}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            type="number"
            size="small"
            label="Alto"
            value={height || ""}
            onChange={(e) => onChangeHeight(e.target.value)}
            inputProps={{ step: "0.1", min: "0" }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default SizeControl;
